import enums from "../../../utils/enums";

export default {
    roleList: [
        {
            label: "全部",
            value: 0,
            icon: "appstore"
        },
        {
            label: "我创建的",
            value: 1
        },
        {
            label: "我管理的",
            value: 2
        },
        {
            label: "我拍摄的",
            value: 4
        },
        {
            label: "我修图的",
            value: 8
        },
    ],
    roleName: enums.Role.roleName
}
